// index-family-page.component.ts
// Vendor libraries
import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../search/static/search/ts/features/base-autocomplete/components/base-autocomplete.component";
import * as i2 from "IndicesApp/ts/apps/index-family-app/components/indices-page-gainers-losers/indices-page-gainers-losers.component";
import * as i3 from "IndicesApp/ts/apps/index-family-app/components/family-indices-table/family-indices-table.component";
export class IndexFamilyPageComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.currFamilyName = this.eltRef.nativeElement.getAttribute('currFamilyName');
    }
    redirectToIndex(autocompleteResult) {
        window.location.href = autocompleteResult.url;
    }
}
IndexFamilyPageComponent.ɵfac = function IndexFamilyPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || IndexFamilyPageComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
IndexFamilyPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: IndexFamilyPageComponent, selectors: [["ycn-index-family-page"]], standalone: false, decls: 40, vars: 8, consts: [[1, "page", "ng-scope"], [1, "container"], [1, "page-header", "row"], [1, "page-title", "col-auto"], [1, "page-title-wrap"], [1, "d-flex"], [1, "page-name"], [1, "page-name-text"], [1, "page-header-navigation-inline"], ["href", "/indices", 1, "text-blue"], [1, "page-header-navigation-title"], ["href", "/indices/families", 1, "text-blue"], [1, "page-header-navigation-title", "text-bold"], [1, "page-header-actions"], [1, "row", "visible-md-flex"], [1, "col-i-md-4", "d-flex", "align-items-end", "form-row"], [1, "flex-auto", "row", "no-gutters", "align-items-baseline"], [1, "col-auto"], [1, "form-label", "form-label-thin", "mr-1"], [1, "col"], [3, "submitHandler", "placeholder", "searchType", "buttonType", "showMoreResultsUrl"], [1, "page-body"], [1, "panel", "panel-data", "panel-stocks"], [1, "panel-header"], [1, "panel-title"], [1, "panel-content"], [1, "mb-2"], [3, "currFamilyName"], [3, "indexFamily"]], template: function IndexFamilyPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div", 6)(7, "span", 7);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(9, "div", 8)(10, "a", 9)(11, "span", 10);
        i0.ɵɵtext(12, "Indices");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "span");
        i0.ɵɵtext(14, "\u00A0/\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "a", 11)(16, "span", 10);
        i0.ɵɵtext(17, "Families");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(18, "span");
        i0.ɵɵtext(19, "\u00A0/\u00A0");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "span", 12);
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(22, "div", 13)(23, "div", 14)(24, "div", 15)(25, "div", 16)(26, "div", 17)(27, "div", 18);
        i0.ɵɵtext(28, "Search All Indices");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(29, "div", 19)(30, "ycn-base-autocomplete", 20);
        i0.ɵɵlistener("submitHandler", function IndexFamilyPageComponent_Template_ycn_base_autocomplete_submitHandler_30_listener($event) { return ctx.redirectToIndex($event); });
        i0.ɵɵelementEnd()()()()()()();
        i0.ɵɵelementStart(31, "div", 21)(32, "div", 22)(33, "div", 23)(34, "h3", 24);
        i0.ɵɵtext(35, "Performance by Family");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(36, "div", 25)(37, "div", 26);
        i0.ɵɵelement(38, "ycn-indices-page-gainers-losers", 27);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(39, "ycn-family-indices-table", 28);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵtextInterpolate1("Indices: Families - ", ctx.currFamilyName);
        i0.ɵɵadvance(13);
        i0.ɵɵtextInterpolate(ctx.currFamilyName);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("placeholder", "Search")("searchType", "index")("buttonType", "icon-search")("showMoreResultsUrl", true);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("currFamilyName", ctx.currFamilyName);
        i0.ɵɵadvance();
        i0.ɵɵproperty("indexFamily", ctx.currFamilyName);
    } }, dependencies: [i1.BaseAutocompleteComponent, i2.IndicesPageGainersLosersComponent, i3.FamilyIndicesTableComponent], encapsulation: 2 });
